import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _withScopeId = n => (_pushScopeId("data-v-e9352e2e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "no-data-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no-data",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "empty-text"
};
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'no-data',
  props: {
    emptyText: {
      type: String,
      default: '暂无数据'
    }
  },
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, _toDisplayString(__props.emptyText), 1)]);
    };
  }
});